module.exports = "<div>{{address.addressLine1}}</div>\n<div>{{address.addressLine2}}</div>\n<div>{{address.addressLine3}}</div>\n<div>{{address.postalCode}}</div>\n<div>{{address.city}}</div>\n<div>{{address.state}}</div>\n"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/widgets/inputs/templates/address-summary-PostCodeBeforeCity.html
// module id = 765
// module chunks = 0